import type { ArDoc } from './ar.js';
import { apiFetch } from './client.js';

// Лимит ДЗ в клиентском кабинете не показывается — сервер поле не отдаёт.
export type ClientFinanceSummary = {
  legalEntityName: string;
  inn: string | null;
  summary: {
    debtTke: number | null;
    debtNpi: number | null;
    debtTotal: number;
    ourDebtTotal: number;
    balanceTotal: number;
  } | null;
  report: {
    uploadedAt: string;
    reportDate: string | null;
  } | null;
};

// Формат совместим с менеджерским /api/ar/current — фронт использует PivotTab.
export type ClientFinanceDocuments = {
  legalEntityName: string;
  inn: string | null;
  report: {
    uploadedAt: string;
    reportDate: string | null;
  } | null;
  documents: ArDoc[];
};

/** Агрегаты дашборда: KPI, динамика долга, график платежей, структура. */
export type ClientFinanceDetails = {
  legalEntityName: string;
  inn: string | null;
  report: {
    uploadedAt: string;
    reportDate: string | null;
  } | null;
  kpi: {
    debtTotal: number;
    overdueTotal: number;
    nearestPayment: { date: string; amount: number } | null;
  };
  // Точек может быть 0–1, пока копится история снапшотов, — график рисуем от 2.
  dynamics: Array<{ reportDate: string; debtTotal: number }>;
  schedule: Array<{
    planDate: string;
    docNumber: string | null;
    remaining: number;
    overdueDays: number | null;
  }>;
  structure: { current: number; overdue: number };
};

export const clientFinanceApi = {
  summary: () => apiFetch<ClientFinanceSummary>('/api/client/finance/summary'),
  documents: () => apiFetch<ClientFinanceDocuments>('/api/client/finance/documents'),
  details: () => apiFetch<ClientFinanceDetails>('/api/client/finance/details'),
};
